import React from 'react'

import { CSS } from '@dnd-kit/utilities'
import { useSortable } from '@dnd-kit/sortable'

import { AttachmentDataWithRequiredAttachment, Styles } from '../../../../../../../../@types/types'
import { convertImageUrl } from '../../../../../../../../services/conversion/conversionServices'

import styles from '../AttachmentsList.module.css'
import Options from '../common/Options'
import TitleLabel from '../common/TitleLabel'
import { useMultimediaDetailsModalContext } from '../../multimediaDetailsModalContext/multimediaModalsContext'
import { useTranslation } from 'react-i18next'

export const Picture: React.FC<{
  data: AttachmentDataWithRequiredAttachment
  index: number
}> = (props) => {
  const { listeners, isDragging, setNodeRef, transform, transition } = useSortable({
    id: props.data.attachment!!.id,
  })
  const { t } = useTranslation()
  const { openModalForAttachmentIndex } = useMultimediaDetailsModalContext()

  const dynamicStyles: Styles = {
    container: {
      transform: CSS.Transform.toString(transform),
      transition: transition || undefined,
      visibility: isDragging ? 'hidden' : undefined,
    },
    picture: {
      backgroundImage: `url(${convertImageUrl('320', '160', props.data.attachment?.url || '')})`,
    },
  }

  const isFloorPlan = !!props.data.attachment.floorplan
  const isTitlePicture = props.index === 0
  const floorPlanTitle = t('wizard.screen.multimedia.floorplan')

  const title = isFloorPlan ? floorPlanTitle : props.data.attachment!.title || ''

  return (
    <div className='grid-item one-half picture-container'>
      <div
        data-testid='picture-container'
        ref={setNodeRef}
        className={`${styles.attachmentContainer} ${isTitlePicture && styles.titlePicture}  border-radius-rounded`}
        style={dynamicStyles.container}
        onClick={() => openModalForAttachmentIndex(props.index)}
      >
        <div {...listeners} aria-label={title} className={`${styles.picture}`} style={dynamicStyles.picture} />
        <TitleLabel title={title} />
        <Options />
      </div>
    </div>
  )
}

export default Picture
